import React from 'react';

interface IdentityCircleIconProps {
  fill?: string;
  className?: string;
}

export const IdentityCircleIcon: React.FC<IdentityCircleIconProps> = ({ fill = '#85ADAA', className = '' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" fill="none" className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.2272 4.38976C32.2879 2.06519 37.899 0.424634 43.7832 0.013129L43.7832 6.58081C39.1341 6.99228 34.6184 8.22136 30.5143 10.1399L27.2332 4.39523L27.2272 4.38976Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.34704 20.534C11.6281 15.7458 15.7323 11.6417 20.5204 8.36062L23.668 13.9718C19.9754 16.7078 16.6888 19.9889 13.9527 23.687L8.34157 20.5394L8.34704 20.534Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.00566864 43.7905C0.417147 37.9069 2.05773 32.3012 4.3823 27.2345L10.127 30.5156C8.21389 34.6198 6.97938 39.1354 6.56788 43.7845L0.000199318 43.7845L0.00566864 43.7905Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.7479 95.6365C22.5787 95.6365 1.91862 76.3444 0.00610735 51.7197L6.5738 51.7197C8.48686 72.6521 26.1381 89.2012 47.7544 89.2012C70.5993 89.2012 89.2073 70.5932 89.2073 47.7483C89.2073 26.132 72.6514 8.48703 51.7259 6.56767L51.7259 -3.10739e-06C76.3505 1.91306 95.6426 22.5726 95.6426 47.7418C95.6426 74.1463 74.1658 95.6231 47.7613 95.6231L47.7479 95.6365Z"
      fill={fill}
    />
  </svg>
);
